module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noDataWrap"
  }, [(_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": require("../assets/home/emptyData.png?v1232")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": require("../assets/stats/Stats_nulldata.png?v1232")
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sorry",
    class: {
      'grayColor': _vm.whiteMode
    }
  }, [_vm._v("Sorry , no content yet")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5929cd20","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nodata.vue
// module id = 543
// module chunks = 3 4 5 6